import { render, staticRenderFns } from "./inputFile.vue?vue&type=template&id=630753f0&scoped=true&"
import script from "./inputFile.vue?vue&type=script&lang=js&"
export * from "./inputFile.vue?vue&type=script&lang=js&"
import style0 from "./inputFile.vue?vue&type=style&index=0&id=630753f0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630753f0",
  null
  
)

export default component.exports